import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { DashCounters } from '@apps/auth/domain/models/back/dash-counters';
import { User } from '@apps/auth/domain/models/back';

export const BackAuthCountersRequested = createAction(
    '[BACK-AUTH-COUNTERS] Back Auth Counters Requested'
);

export const BackAuthCountersLoaded = createAction(
    '[BACK-AUTH-COUNTERS] Back Auth Counters Loaded',
    props<{ entitiesCounters: DashCounters, usersCounters: DashCounters }>()
);

export const BackAuthUsersExternalODataRequested = createAction(
    '[BACK-AUTH-USERS] Back Auth Users External OData Requested'
);

export const BackAuthUsersExternalODataLoaded = createAction(
    '[BACK-AUTH-USERS] Back Auth Users External OData Loaded',
    props<{ users: User[] }>()
);
export const BackAuthUsersExternalODataFailed = createAction(
    '[BACK-AUTH-USERS] Back Auth Users External OData Failed',
    props<{ err: any }>()
);
export const BackAuthUsersExternalQsWordSet = createAction(
    '[BACK-AUTH-USERS] Back Auth Users External QsWord Set',
    props<{ qsWord: string }>()
);
export const BackAuthUsersExternalIdentityUpdated = createAction(
    '[BACK-AUTH-USER] Back Auth Users External Identity Updated',
    props<{ user: Update<User> }>()
);
export const BackAuthExternalUserHabsUpdated = createAction(
    '[BACK-AUTH-USER] Back Auth External User Habs Updated',
    props<{ user: Update<User> }>()
);
export const BackAuthUsersDeactivateExternalUserSucceeded = createAction(
    '[BACK-AUTH-USER] Back Auth Users Deactivate External User Requested',
    props<{ userId: string; }>()
);
export const BackAuthUsersDeactivateExternalUserFailed = createAction(
    '[BACK-AUTH-USER] Back Auth Users Deactivate External User Failed'
);
export const BackAuthUsersActivateExternalUserSucceeded = createAction(
    '[BACK-AUTH-USER] Back Auth Users Activate External User Requested',
    props<{ userId: string; }>()
);
export const BackAuthUsersActivateExternalUserFailed = createAction(
    '[BACK-AUTH-USER] Back Auth Users Activate External User Failed'
);
export const BackAuthUsersExternalUserUpdated = createAction(
    '[BACK-AUTH-USER] Back Auth Users External User Updated',
    props<User>()
);
export const BackAuthUsersExternalAddQueryParameterRequested = createAction(
    '[BACK-AUTH-USER] Back Auth Users External Add Query Parameter Requested',
    props<{ key: string, value: any }>()
);
export const BackAuthUsersExternalRemoveQueryParameterRequested = createAction(
    '[BACK-AUTH-USER] Back Auth Users External Remove Query Parameter Requested',
    props<{ key: string }>()
);
